import * as React from 'react'
// libs
import { useSelector } from 'react-redux'
import { FieldArray, formValueSelector } from 'redux-form'
// graphql
import { RISK_TEMPLATE_SELECT_QUERY } from 'graphql/risk/queries'
// types
import { IRiskTemplate } from 'types/graphql'
// components
import renderUsers from './components/UserPermissions'
import { ReduxEntitySelect } from 'components/FormElements/ReduxForm'
// constants
import { Forms } from 'constants/index'
import { SELECT_GROUP_LABELS } from 'constants/forms'
import { CAN_VIEW_OBJECTS_OPTIONS } from 'constants/security'
// views
import { ViewConditionWrapper, Wrapper } from './views'
// utils
import { get } from 'lodash'
import { map, pipe } from 'lodash/fp'
import { required } from 'utils'
import { safeGetOr } from 'utils/fp'
import { userAndPositionProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

const BusinessRule: React.FC = () => {
  const selector = formValueSelector(Forms.GROUP_SECURITY_CREATE_FORM)

  const { users } = useSelector((state) => ({
    users: selector(state, 'users') || []
  }))

  const usersIds = users.map(({ user }) => get(user, 'value'))

  const getTemplatesOptions = (data) => {
    const templates = pipe(
      safeGetOr<IRiskTemplate, any, IRiskTemplate[]>([], 'data.riskTemplates.data'),
      map<IRiskTemplate, Record<string, any>>(({ id, name }) => ({ label: name, value: id }))
    )(data)

    return [...CAN_VIEW_OBJECTS_OPTIONS, { label: SELECT_GROUP_LABELS.TEMPLATES, options: templates }]
  }

  const getUserOptions = (data) => {
    return [{ label: '(All Users)', value: 'ALL' }, ...userAndPositionProps.getOptions(data)]
  }

  return (
    <Wrapper>
      <FieldArray name={'users'} usersIds={usersIds} component={renderUsers as any} getOptions={getUserOptions} />
      <ViewConditionWrapper>
        Can View
        <ReduxEntitySelect
          name='canView'
          validate={required}
          getOptions={getTemplatesOptions}
          query={RISK_TEMPLATE_SELECT_QUERY}
          handleSearch={({ search, refetch }) => refetch({ filter: { name: search } })}
        />
      </ViewConditionWrapper>
    </Wrapper>
  )
}

export default BusinessRule
